// extracted by mini-css-extract-plugin
export default {"appBar":"header_appBar__Q5OyQ","floatingHeader":"header_floatingHeader__ciSO6","logosec":"header_logosec__osuLb","logo":"header_logo__spNSL"};